var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',[_c('v-card',[_c('v-card-title',[_c('h3',{staticClass:"mx-auto"},[_vm._v(" Welcome "+_vm._s(_vm.name)+" ")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }